/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event) {

    // GSAP matchMedia
    var mm = gsap.matchMedia();

    // GSAP logos animations
    var logosContainer = document.querySelector('.wp-block-create-block-swiftpay-logos-loop');
    var logosHeading = document.querySelector('.logos-loop-content h2');
    var logosHeadingAnimated = new SplitType(logosHeading);

    function initLogosScrollAnimation(){
        gsap.fromTo(logosHeadingAnimated.chars, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: "power3.inOut",
            stagger: 0.01,
            scrollTrigger: {
                trigger: logosContainer,
                start: "top +=85%",
                end: "bottom bottom"
            }
        });
    }

    mm.add("(min-width: 1024px)", function() {
        initLogosScrollAnimation();
    });

    // Create infinite slider with ScrollTrigger
    function createInfiniteSlider() {
        const itemLists = [
            document.querySelector('.logos-row-1'),
            document.querySelector('.logos-row-2'),
            document.querySelector('.logos-row-3')
        ];
        const itemsContainer = document.querySelector('.wp-block-create-block-swiftpay-logos-loop');

        if (!itemLists[0] || !itemLists[1] || !itemLists[2] || !itemsContainer) return;

        itemLists.forEach((itemList, index) => {
            const items = Array.from(itemList.children);
            const itemWidth = items[0].offsetWidth;
            const containerWidth = itemsContainer.offsetWidth;
            const itemsNeeded = Math.ceil(containerWidth / itemWidth) + 1;

            // Clone items to fill the row
            for (let i = 0; i < itemsNeeded; i++) {
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    itemList.appendChild(clone);
                });
            }

            const totalWidth = itemList.scrollWidth;

            // Set the starting position based on row index
            if (index === 1) {
                gsap.set(itemList, { x: 0 });
            } else if (index === 2) {
                gsap.set(itemList, { x: -(totalWidth / 2) + (containerWidth / 3) });
            } else {
                gsap.set(itemList, { x: -totalWidth / 2 });
            }

            // Infinite scrolling animation with ScrollTrigger
            ScrollTrigger.create({
                trigger: itemsContainer,
                start: "top bottom", // Start animation when the slider is fully in view
                end: "bottom top", // End when fully out of view
                onEnter: () => {
                    if (index === 1) {
                        gsap.to(itemList, {
                            x: `-=${totalWidth / 2}`,
                            duration: 3000,
                            ease: 'none',
                            repeat: -1,
                            modifiers: {
                                x: gsap.utils.unitize(x => (parseFloat(x) % totalWidth))
                            }
                        });
                    } else {
                        gsap.to(itemList, {
                            x: `+=${totalWidth / 2}`,
                            duration: 1800,
                            ease: 'none',
                            repeat: -1,
                            modifiers: {
                                x: gsap.utils.unitize(x => (parseFloat(x) % totalWidth))
                            }
                        });
                    }
                },
            });
        });
    }

    // Initialize infinite slider with scrollTrigger
    createInfiniteSlider();
});
